import React from "react";
import SubCourseWrapper from "../sub-course-wrapper";
import ProfessionalCourses from "./courses";
import "./index.scss";
import SubscribtionRequest from "./subscribtion-request";

export const ProfessionalLicenseText = "الرخصة المهنية";

export default function ProfessionalLicense({
  categoryData,
  showProLicense = false,
  showGeneralCourse = false,
  showSpecialityCourse = false,
}) {
  return (
    <div className="container professional-license-wrapper">
      {showProLicense ? (
        <>
          {/* <SubCourseWrapper /> */}
          <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/subcoursewrappernew.png"
                  }
                  height="100%"
                  width="100%"
                  className="mr-2 contain-img"
                  alt="refund"
                />
          <ProfessionalCourses
            {...{ categoryData, showGeneralCourse, showSpecialityCourse }}
          />
        </>
      ) : null}
    </div>
  );
}
